angular.module("qbePortal").controller("paymentsFormController", [
	"$rootScope",
	"$scope",
	"$state",
	"$window",
	"userInputRepository",
	"paymentService",
	"Util",
	"storage",
	"gtmService",
	"paymentLoggerService",
	"CREDIT_CARD_ATTEMPT",
	function(
		$rootScope,
		$scope,
		$state,
		$window,
		userInputRepository,
		paymentService,
		util,
		storage,
		gtmService,
		paymentLoggerService,
		CREDIT_CARD_ATTEMPT
	) {
		var $ctrl = this;

		if ($window.qbe.fieldLabels.buttonLabel) {
			$ctrl.closeWindowLabel =
				$window.qbe.fieldLabels.buttonLabel.closeWindow;
			$ctrl.payYourBillNowLabel =
				$window.qbe.fieldLabels.buttonLabel.payYourBillNow;
			$ctrl.printLabel = $window.qbe.fieldLabels.buttonLabel.print;
			$ctrl.payMoreBillLabel =
				$window.qbe.fieldLabels.buttonLabel.payMoreBill;
			$ctrl.chatAgentLabel =
				$window.qbe.fieldLabels.buttonLabel.chatAgent;
			$ctrl.callAgentLabel =
				$window.qbe.fieldLabels.buttonLabel.callAgent;
		}

		if ($window.qbe.fieldLabels.config) {
			$ctrl.returnDeclineURLPath =
				$window.qbe.fieldLabels.config.DeclinePath;
			$ctrl.paymentsPath = $window.qbe.fieldLabels.config.PaymentsPath;
		}

		if ($window.qbe.fieldLabels.frequentlyAsked) {
			$ctrl.frequentlyAsked =
				$window.qbe.fieldLabels.frequentlyAsked.list;
			$ctrl.frequentlyAskedTitle = qbe.fieldLabels.frequentlyAsked;
		}

		$ctrl.amountDue = qbe.fieldLabels.amountDue;
		$ctrl.headBar = qbe.fieldLabels.headBar;
		$ctrl.paymentDate = moment().format("Do MMM. YYYY");
		$ctrl.showQbAmountDue = false;

		if ($ctrl.headBar) {
			$ctrl.headBar.click = function() {
				/* gtm track phone click */
				gtmService.trackStandardEvent('click button', 'phone', '', false);
				/* end gtm track phone click */
			};
		}

		if (qbe.fieldLabels.otherWaysToPay) {
			$ctrl.otherWaysToPay = qbe.fieldLabels.otherWaysToPay.list;
		}

		if ($window.qbe.fieldLabels.paymentConfirmation) {
			$ctrl.paymentConfirmationLabel =
				$window.qbe.fieldLabels.paymentConfirmation.title;
			$ctrl.paymentConfirmationDescription =
				$window.qbe.fieldLabels.paymentConfirmation.description;
			$ctrl.paymentConfirmationSubDescription =
				$window.qbe.fieldLabels.paymentConfirmation.subDescription;
		}

		if ($window.qbe.fieldLabels.paymentConfirmationSummary) {
			$ctrl.paymentConfirmationSummaryLabel =
				$window.qbe.fieldLabels.paymentConfirmationSummary.title;
			$ctrl.paymentConfirmationSummaryDetailsLabel =
				$window.qbe.fieldLabels.paymentConfirmationSummary.options;				
		}

		if ($window.qbe.fieldLabels.enterPaymentRef) {
			$ctrl.phoneNumber = $window.qbe.fieldLabels.enterPaymentRef.phone;
		}

		$ctrl.totalSteps = 2;
		$ctrl.initStep = 1;
		$ctrl.stepNum = null;
		$ctrl.Completed = false;
		$ctrl.ctpCompleted = false;
		$ctrl.showPayButton = true;
		$ctrl.paymentAttempt = 0;

		function ctpStepCounter(step) {
			var currentStep = step;

			for (var i = 0; i <= currentStep; i++) {
				$ctrl.stepNum = i;
			}
		}

		$ctrl.trackWindowPrint = function() {
			gtmService.trackStandardEvent('click link', 'print', '', false);
		};

		// This will catch the success callback
		var paypalConfirmation = storage.getItem("paypal-confirm-details");
		if (paypalConfirmation.isSuccess) {
			var formDetails = storage.getItem("confirmation-details");
			var paymentRef = formDetails.referenceNumber;
			(receiptNum = paypalConfirmation.receiptNumber),
				(amountPay = parseFloat(formDetails.amount.amountPay).toFixed(
					2
				)),
				(paymentDate = $ctrl.paymentDate);

			$ctrl.paymentConfirmationSummaryDetailsValue = [
				paymentRef,
				receiptNum,
				"$" + amountPay,
				paymentDate
			];

			loadAmount(amountPay);

			//dd-6181 - call gtm service on payment complete
			gtmService.trackUnauthPayments($state.current, formDetails, 'payPal', receiptNum, paypalConfirmation.policyNumber);

			storage.removeItem("paypal-confirm-details");			
		} else if (paypalConfirmation.isSuccess === false) {
			storage.removeItem("paypal-confirm-details");
			storage.setItem("payment-error-details", {
				mode: "paypal"
			});
			$state.go("payments.payments");
		}

		var creditCardConfirmation = storage.getItem(
			"creditcard-confirm-details"
		);
		if (creditCardConfirmation.isSuccess) {
			var formDetails = storage.getItem("confirmation-details");
			var paymentRef = formDetails.referenceNumber;
			(receiptNum = creditCardConfirmation.receiptNumber),
				(amountPay = parseFloat(formDetails.amount.amountPay).toFixed(
					2
				)),
				(paymentDate = $ctrl.paymentDate);

			$ctrl.paymentConfirmationSummaryDetailsValue = [
				paymentRef,
				receiptNum,
				"$" + amountPay,
				paymentDate
			];
			loadAmount(amountPay);
			storage.removeItem("creditcard-confirm-details");

			//dd-6181 - call gtm service on payment complete
			gtmService.trackUnauthPayments($state.current, formDetails, 'creditCard', receiptNum, formDetails.policyNumber);
		} else if (creditCardConfirmation.isSuccess === false) {
			storage.removeItem("creditcard-confirm-details");
			storage.setItem("payment-error-details", {
				mode: "cc"
			});
			$state.go("payments.payments");
		}

		var directDebitConfirmation = storage.getItem(
			"direct-debit-confirm-details"
		);
		if (directDebitConfirmation.isSuccess) {
			var formDetails = storage.getItem("confirmation-details");
			var paymentRef = formDetails.referenceNumber,
				amountPay = parseFloat(formDetails.amount.amountPay).toFixed(2),
				paymentDate = $ctrl.paymentDate;

			$ctrl.paymentConfirmationSummaryDetailsValue = [
				paymentRef,
				null,
				"$" + amountPay,
				paymentDate
			];
			loadAmount(amountPay);
			storage.removeItem("direct-debit-confirm-details");

			$ctrl.paymentConfirmationSubDescription =
				$window.qbe.fieldLabels.paymentConfirmation.bankSubDescription;

			//dd-6181 - call gtm service on payment complete
			gtmService.trackUnauthPayments($state.current, formDetails, 'bankAccount', directDebitConfirmation.receiptNumber, directDebitConfirmation.policyNumber);
		} else if (directDebitConfirmation.isSuccess === false) {
			storage.removeItem("direct-debit-confirm-details");
			$state.go("payments.payments");
		}

		function loadAmount(amountPay) {
			$ctrl.amountDue.amountPay = amountPay;
			var cents = amountPay.substring(amountPay.indexOf("."));
			$ctrl.amountDue.amountCents = cents;

			var dollars = amountPay.substring(0, amountPay.indexOf("."));
			$ctrl.amountDue.amountDollars = dollars;
		}

		$ctrl.cybersourceiFrameUrl = $state.href(
			"cybersourcePaymentForm",
			null,
			{
				absolute: true
			}
		);

		$ctrl.addCybersourceiFrame = false;

		$ctrl.elementName = "Form Controller";

		$ctrl.validationErrors = null;
		$ctrl.sections = {};
		$ctrl.state = $state;
		$ctrl.storage = storage;
		$ctrl.showConfirm = false;
		$ctrl.showThankYou = false;
		$ctrl.showSwitchButton = false;
		$ctrl.isConfirmed = false;
		$ctrl.closeWindow = function() {
			/* gtm track close window */
			gtmService.trackStandardEvent('click link', 'exit', '', false);
			/* end gtm track close window */

			$scope.$destroy();
			window.location.href =
				$window.qbe.fieldLabels.buttonLabel.targetUrl;					
		};

		$ctrl.goToPayments = function() {
			window.location.href = util.linkBuilder($ctrl.paymentsPath);
		};		

		function getDefaultValues() {
			return {
				paybillForm: {
					selectInsuranceType: {
						creditCardForm: {
							ccName: "",
							cvcNum: ""
						}
					}
				}
			};
		}

		/**
		 * QbFormSections register themselves with the form controller.
		 * This is done automatically by the form section upon initialisation.
		 * @name : name of the form section
		 * @init : function callback initialise the section
		 * @getValueFn: function callback to get the value of the section.
		 */
		$ctrl.registerSection = function(name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn
			};
		};

		/**
		 * Any generic breaking errors should broadcast 'error' to the rootScope. This will cause redirection
		 * to the main error page.
		 */
		$scope.$on("error", function(event, error) {
			$state.go("error", error);
		});

		function getUserInput() {
			var formData = getFormInput();
			userInputRepository.update(formData);
			return userInputRepository.get(getDefaultValues());
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}
			return formData;
		}

		$scope.$on("pay-now-button", function(event, args) {
			if (args != "QBEProducts") {
				$ctrl.showPayButton = false;
			} else {
				$ctrl.showPayButton = true;
			}
		});

		$scope.$on("show-form-entry", function(event, args) {
			ctpStepCounter($ctrl.initStep);
			$ctrl.showConfirm = false;
			$ctrl.showThankYou = false;
			$ctrl.isConfirmed = false;
			$scope.$broadcast("show-hint");
		});

		$scope.$on("confirm-switch", function(event, args) {
			$ctrl.showConfirm = false;
			$ctrl.showThankYou = true;
			$ctrl.ctpCompleted = true;

			$scope.$broadcast("switch-to-QBE", $ctrl.core.isEligible);
		});

		/**
		 * Scrolls a field into view when an error is clicked
		 * @param {Object} error Error object with key `name`
		 */
		$ctrl.showInView = function(error) {
			scrollViewTo($('[name="' + error.name + '"]'));
		};

		function scrollViewTo($element) {
			var offset = $element.offset();
			if (offset) {
				$("html, body").animate({
					scrollTop: offset.top - 50,
					scrollLeft: offset.left
				});
			}
		}

		// PAYMENTS FORM START
		$scope.$on("billUpdate", function(event, details) {
			if (details) {
				$ctrl.amountDue.amountPay = details.amount;
				if (details.amount.indexOf(".") > 0) {
					var cents = details.amount.substring(
						details.amount.indexOf(".")
					);
					$ctrl.amountDue.amountCents = cents;

					var dollars = details.amount.substring(
						0,
						details.amount.indexOf(".")
					);
					$ctrl.amountDue.amountDollars = dollars;
				} else {
					$ctrl.amountDue.amountCents = "00";
					$ctrl.amountDue.amountDollars = details.amount;
				}

				$ctrl.amountDue.reference_number = details.reference_number;
				$ctrl.amountDue.referenceId = details.referenceId;
				$ctrl.amountDue.paymentType = details.paymentType;
			} else {
				$ctrl.amountDue.amountDollars = null;
				$ctrl.showQbAmountDue = false;
			}
		});

		/* gtm track payment type select in payment details page */
		$scope.$on("trackPaymentDetailsPaymentType", function(event, paymentType) {
			if (paymentType) {
				var pType = 'bankAccount';
				if (paymentType == 'credit-card') {
					pType = 'creditCard';
				}
				else if (paymentType == 'paypal') {
					pType = 'payPal';
				}
				gtmService.trackPayBillVirtualPageDetails($ctrl.amountDue.reference_number, $ctrl.amountDue.referenceId, pType);
			}
		});
		/* end gtm track payment type select in payment details page */

		$scope.$on("toggle-amount-due", function() {
			$ctrl.showQbAmountDue = $ctrl.amountDue.amountDollars != null;
		});

		$scope.$on("set-micoform-instance", function(event, instance){
			$ctrl.microformInstance = instance;
		});

		function isCrditCardPaymentMethod(howToPay) {
			return howToPay === 'credit-card';
		}

		function validateCybersourceCreditCardField() {
			var cardNumberContainerValidClass = document.getElementsByClassName('flex-microform-valid');
			return (cardNumberContainerValidClass && cardNumberContainerValidClass.length > 0) ? true : false;
		}
		$ctrl.payBillNow = function(form) {
			var formData = getUserInput();
			var payByCreditCard = isCrditCardPaymentMethod(formData.paybillForm.selectInsuranceType.howToPay);

			$scope.$broadcast("form-submitted");

			$ctrl.showErrorSummary = false;
			isInvalid = form.$invalid;
			
			if (payByCreditCard) {
				//init refresh cvc validation stataus
				$scope.$broadcast("credit-card-cvc-isvalid", true);

				if (!validateCybersourceCreditCardField()) {
					if (!isInvalid) {
						isInvalid = true;
					}				
					$scope.$broadcast("credit-card-number-isvalid", false);
				}
				else {
					$scope.$broadcast("credit-card-number-isvalid", true);
				}
			}
			
			if (isInvalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				if ($("#combinedValidationListing").length) {
					scrollViewTo($("#combinedValidationListing"));
				} else {
					scrollViewTo($("#content"));
				}
				return;
			}

			var formData = getUserInput();
			if (!formData.paybillForm.selectInsuranceType.howToPay) {
				return;
			}

			if (
				formData.paybillForm.selectInsuranceType.selectInsuranceType ===
				null
			) {
				return false;
			} else
				$ctrl.selectInsuranceType =
					formData.paybillForm.selectInsuranceType.selectInsuranceType;

			// dd-6181 - call gtm service to track payment
			gtmService.trackUnauthPayments(
				$state.current,
				formData.paybillForm.selectInsuranceType
			);

			$ctrl.paymentAttempt++;

			if (formData.paybillForm.selectInsuranceType.howToPay == "paypal") {
				paymentService.unAuthPaypalPayment(
					{
						referenceNumber: $ctrl.amountDue.referenceId,
						paymentType: $ctrl.amountDue.paymentType,
						redirectUrl: ""
					},
					// on successfully calling the Create Paypal Payment service
					function(redirectUrl) {
						storage.setItem("confirmation-details", {
							referenceNumber: $ctrl.amountDue.reference_number,
							amount: $ctrl.amountDue,
							transactionId: $ctrl.selectInsuranceType
						});
						$window.location.href = redirectUrl;
					},
					// on error
					function(errorResponse) {
						paymentLoggerService.trackQuoteStatus(
							"paypal payment error",
							"show oh snap page",
							errorResponse
						);
						storage.removeItem("unauth-reference");
						console.error(errorResponse);
					}
				);
			} else if (
				formData.paybillForm.selectInsuranceType.howToPay ==
				"bank-account"
			) {
				$rootScope.$broadcast("loading-animation-start");

				paymentService.unAuthDirectDebitPayment(
					{
						amountPay: $ctrl.amountDue.amountPay,
						referenceNumber: $ctrl.amountDue.referenceId,
						paymentType: $ctrl.amountDue.paymentType,
						bsb:
							formData.paybillForm.selectInsuranceType
								.bankAccountForm.bsb,
						accountNumber:
							formData.paybillForm.selectInsuranceType
								.bankAccountForm.accountNumber,
						accountName:
							formData.paybillForm.selectInsuranceType
								.bankAccountForm.accountName
					},
					// on successfully calling the Payment service
					function(response) {
						if (response.status === "SUCCESS") {
							storage.setItem("direct-debit-confirm-details", {
								isSuccess: true
							});

							storage.setItem("confirmation-details", {
								referenceNumber:
									$ctrl.amountDue.reference_number,
								amount: $ctrl.amountDue,
								transactionId: $ctrl.selectInsuranceType
							});

							paymentLoggerService.trackQuoteStatus(
								"payment successful",
								"show done page",
								null
							);
							
							$state.go("payments.complete");
						} else {
							paymentLoggerService.trackQuoteStatus(
								"payment unsuccessful",
								"show error page",
								null
							);
							$rootScope.$broadcast("loading-animation-end");
							$scope.$broadcast("direct-debit-payment-error");
						}
					},
					// on error
					function(errorResponse) {
						paymentLoggerService.trackQuoteStatus(
							"bank debit payment error",
							"show oh snap page",
							errorResponse
						);
						storage.removeItem("unauth-reference");
						$rootScope.$broadcast("loading-animation-end");
						$scope.$broadcast("direct-debit-payment-error");
					}
				);
			} else {
				// pay by credit card
				tokeniseAndPayByCreditCard(
					formData.paybillForm.selectInsuranceType.creditCardForm
				);
			}
		};

		$scope.$on("redirect-payment-decline", function() {
			window.location.href = util.linkBuilder(
				$ctrl.returnDeclineURLPath + "?return=true"
			);
		});

		function setPaymentErrorAfterCybersourceTokenization(err) {
			paymentLoggerService.trackQuoteStatus(
				"payment unsuccessful",
				"return payment page",
				err
			);
			$rootScope.$broadcast(
				"cyber-source-error",
				"Form validation error"
			);
			storage.removeItem("creditcard-confirm-details");
			storage.setItem("payment-error-details", {
				mode: "cc"
			});
			$state.go("payments.payments");

			$scope.$broadcast("credit-card-number-isvalid", false);
			$rootScope.$broadcast("loading-animation-end");
		}
		function setPaymentErrorAfterCybersourceTokenizationCvcInvalid(err) {
			paymentLoggerService.trackQuoteStatus(
				"payment unsuccessful",
				"return payment page",
				err
			);
			$rootScope.$broadcast(
				"cyber-source-error",
				"Form validation error"
			);
			storage.removeItem("creditcard-confirm-details");
			storage.setItem("payment-error-details", {
				mode: "cc"
			});
			$state.go("payments.payments");

			$scope.$broadcast("credit-card-cvc-isvalid", false);
			$rootScope.$broadcast("loading-animation-end");
		}
		function tokeniseAndPayByCreditCard(creditCardForm) {			
			$rootScope.$broadcast("loading-animation-start");

			// Send in optional parameters from other parts of your payment form
			var options = {
				cardExpirationMonth: creditCardForm.expiryMonth,
				cardExpirationYear: new Date().getFullYear().toString().substr(0, 2) + creditCardForm.expiryYear,
				cardCvc: creditCardForm.cvcNum,
				referenceNumber: $ctrl.amountDue.referenceId,
				paymentType: $ctrl.amountDue.paymentType
			};

			$ctrl.microformInstance.createToken(options, function (err, response) {
				if (err) {
					setPaymentErrorAfterCybersourceTokenization(err);
					return;
				}
				else if (response) {		
					if (response.cardType != '001' && response.cardType != '002' && response.cardType != '003') {
						setPaymentErrorAfterCybersourceTokenization(err);
						return;
					}
					else {
						if (response.cardType === '001' || response.cardType === '002') {
							if (creditCardForm.cvcNum && creditCardForm.cvcNum.toString().length != 3) {
								setPaymentErrorAfterCybersourceTokenizationCvcInvalid('Invalid CVC');
								return;
							}
						}
						else if (creditCardForm.cvcNum && creditCardForm.cvcNum.toString().length != 4) {
							setPaymentErrorAfterCybersourceTokenizationCvcInvalid('Invalid CVC');
							return;							
						}						
					}			
				}

				payByCreditCard(creditCardForm, response);
			});
		}

		function payByCreditCard(creditCardForm, flexiResponse) {
			
			paymentService.unAuthCreditCardPayment(
				// pass credit card data
				{
					cardToken: flexiResponse.token,
					cardHolderName: creditCardForm.ccName,
					cvc: creditCardForm.cvcNum,
					type: flexiResponse.cardType,
					cardExpiryDate: creditCardForm.expiryDate,
					referenceNumber: $ctrl.amountDue.referenceId,
					paymentType: $ctrl.amountDue.paymentType
				},
				// on successfully calling the Create Creditcard Payment service
				function(creditCardPaymentData) {
					// make the scope available globally. This data will be used by the iFrame to construct the form that will post to Cybersource
					$window.$controllerScope = $scope;

					// set the data to send to Cybersource to the scope
					$scope.creditCardPaymentData = creditCardPaymentData;
					// set the URL for the iFrame to the Cybersource Payment Form (which will use the `creditCardPaymentData`) to generate and submit the form
					$ctrl.addCybersourceiFrame = true;

					if ($ctrl.paymentAttempt == 2) {
						$ctrl.addCybersourceRetryAttempt = true;
					}

					if ($ctrl.paymentAttempt == CREDIT_CARD_ATTEMPT) {
						$ctrl.addCybersourceLastAttempt = true;
					}
				},
				// on error
				function(errorResponse) {
					paymentLoggerService.trackQuoteStatus(
						"cc payment error",
						"show oh snap page",
						errorResponse
					);
					storage.removeItem("unauth-reference");
					// dd-4003-push error to gtm data layer
					gtmService.trackEvent(errorResponse, "ccPaymentError");
				}
			);
		}

		$scope.onPaymentCallback = function(success, params) {
			$rootScope.$broadcast("loading-animation-end");

			if (success) {
				var confirmationData = {
					policyNumber: params.policyNumber,
					//accountNumber: params.accountNumber,
					receiptNumber: params.receiptNumber,
					isSuccess: params.status === "SUCCESS"
				};

				storage.setItem("creditcard-confirm-details", confirmationData);

				storage.setItem("confirmation-details", {
					referenceNumber: $ctrl.amountDue.reference_number,
					amount: $ctrl.amountDue,
					policyNumber: params.policyNumber,
					transactionId: $ctrl.selectInsuranceType
					// accountNumber: params.accountNumber
				});

				paymentLoggerService.trackQuoteStatus(
					"payment successful",
					"show done page",
					null
				);
				storage.removeItem("unauth-reference");

				// Go to confirmation
				$state.go("payments.complete", confirmationData);
			} else {
				var declineParam = {
					referenceNumber: $ctrl.amountDue.reference_number
				};

				if ($ctrl.paymentAttempt === CREDIT_CARD_ATTEMPT) {
					paymentLoggerService.trackQuoteStatus(
						"payment unsuccessful",
						"show referral page",
						null
					);
					storage.removeItem("unauth-reference");
					$state.go("decline", declineParam);
				} else {
					paymentLoggerService.trackQuoteStatus(
						"payment unsuccessful",
						"show decline page",
						null
					);
					$rootScope.$broadcast(
						"cyber-source-error",
						params.reasonCode
					);
				}
			}
		};

		/**
		 * Takes care of
		 * - registering the labels generated by sitecore
		 * - setting default values
		 * - prepopulating retrieve quote if required.
		 */
		$ctrl.initPage = function() {
			resizePayBills();
			util.dispatchCustomEvent("register-labels");
			ctpStepCounter($ctrl.initStep); //Progress Counter
		};

		function resizePayBills() {
			var footHeight = $(".footer").outerHeight(),
				windowHeight = $(window).height(),
				documentHeight = $(document).height(),
				minHeight;

			if ($(window).outerWidth() >= 768) {
				if (documentHeight > windowHeight) {
					minHeight = documentHeight - footHeight - 5;
				} else {
					minHeight = windowHeight - footHeight - 5;
				}

				$(".col1, .col2").css("min-height", minHeight + "px");
			} else {
				$(".col1, .col2").css("min-height", "auto");
			}
		}
	}
]);
